import Bowser from 'bowser';


export function getMinimumBrowserVersions() {
  return {
    chrome: 95,
    firefox: 80,
    safari: 15,
    edge: 83,
  };
}

export function isBrowserSupported(): boolean {
  try {
    const userAgent = window.navigator.userAgent;
    const browser = Bowser.getParser(userAgent);
    const minVersions = getMinimumBrowserVersions();

    const isBrowserSupported = browser.satisfies({
      chrome: `>=${minVersions.chrome}`,
      firefox: `>=${minVersions.firefox}`,
      safari: `>=${minVersions.safari}`,
      edge: `>=${minVersions.edge}`,
    });
    return isBrowserSupported || false;
  } catch (error) {
    return false;
  }
}
